import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEditTaskState } from './types/edit-task-interface';
import { fetchEditTask } from './actions/fetch-edit-task';

const initialState: IEditTaskState = {
    isLoadingEditTask: false,
    errorEditTask: [],
    EditTaskID: "",
    EditTaskNumber: "",
};

export const EditTask = createSlice({
    name: 'EditTask',
    initialState,
    reducers: {
        resetEditTask: (state) => {
            state.isLoadingEditTask = false;
            state.errorEditTask = [];
            state.EditTaskID = "";
            state.EditTaskNumber = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEditTask.pending, (state) => {
                state.isLoadingEditTask = true;
            })
            .addCase(fetchEditTask.fulfilled, (state, action: PayloadAction<{ taskID: string, taskNumber: string }>) => {
                state.isLoadingEditTask = false;
                state.errorEditTask = [];
                state.EditTaskID = action.payload.taskID;
                state.EditTaskNumber = action.payload.taskNumber;
            })
            .addCase(fetchEditTask.rejected, (state, action) => {
                state.isLoadingEditTask = false;
                state.errorEditTask = action.payload as string[];
                state.EditTaskID = "";
                state.EditTaskNumber = "";
            });
    },
});

export const { resetEditTask } = EditTask.actions;
export default EditTask.reducer;